window.avatarFormatter = function(value, row) {
    let html = '';
    let alt = row.first_name+' '+row.last_name;
    html += '<img src="'+value+'" class="rounded-circle me-2" height="22" alt="'+alt+'" loading="lazy" />';
    return html;
};
